import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UsuarioCertificadoModalSenhaService } from './usuario-certificado-modal-senha.service';
import { EnumTipoAutenticacaoEnvioPortalUnico } from "@catalogo/features/operacional/enums/enum-entities";


@Component({
    selector: 'usuario-certificado',
    templateUrl: './usuario-certificado-modal-senha.component.html',
    styleUrls: ['./usuario-certificado-modal-senha.component.scss'],
    standalone: false
})
export class UsuarioCertificadoModalSenhaComponent implements OnInit {
    public senha = new UntypedFormControl('', [
        Validators.required
    ]);
    public esconderSenha: boolean = true;
    public tipoAutenticacaoPadrao = EnumTipoAutenticacaoEnvioPortalUnico.Padrao;
    public tipoCertificadoUsuario = EnumTipoAutenticacaoEnvioPortalUnico.Usuario;
    
    public opcaoAutenticacaoSelecionada = new UntypedFormControl( null,[
        Validators.required
    ]);
    
    public opcoesCertificado = [];
    
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { logar: boolean, solicitarSenha: boolean, certificadoUsuario: boolean, autenticacaoPadrao: boolean },
        @Inject(UsuarioCertificadoModalSenhaService) public service: UsuarioCertificadoModalSenhaService,
    ) {
        this.opcoesCertificado.push({
            id: EnumTipoAutenticacaoEnvioPortalUnico.Usuario,
            descricao: 'Usuário',
            desabilitado: !this.data.certificadoUsuario
        });
        
        if(this.data.logar){
            this.opcoesCertificado.push({
                id: EnumTipoAutenticacaoEnvioPortalUnico.Padrao,
                descricao: 'Padrão',
                desabilitado: !this.data.autenticacaoPadrao
            });
        }
        
        if(!this.data.certificadoUsuario && this.data.autenticacaoPadrao ){
            this.opcaoAutenticacaoSelecionada.setValue(EnumTipoAutenticacaoEnvioPortalUnico.Padrao);
        }else{
            this.opcaoAutenticacaoSelecionada.setValue(EnumTipoAutenticacaoEnvioPortalUnico.Usuario);
        }
    }
    
    ngOnInit(): void {
    }
}
